/**
 * Encaptulates functionality to store and retrieve Jobs data from the data store
 */
import { VersionedObjectPersistence } from "src/common/managers/ESVersionedPersistance";
import { JobType, JobTypePersistenceInterface } from "./JobState";


export class JobTypePersistence extends VersionedObjectPersistence<JobType> implements JobTypePersistenceInterface {

   private static indexMappings =
      {
         "properties": {
         }
      }
   private static idGetter = (object) => { return object.id; }

   constructor(objectsESIndexName: string, userId: string) {

      super(objectsESIndexName, userId, JobTypePersistence.indexMappings, JobTypePersistence.idGetter)

   }

}
